var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ComponentInstanceEditBar.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-46185816!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ComponentInstanceEditBar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ComponentInstanceEditBar.vue
// module id = 646
// module chunks = 2